/**
 * Created by mac on 2017/6/1.
 */
import { constantRouterMap } from '../../router'
import route from '@/router/index'

function hasPermission(roles,route) {
  if (!route.pm || route.pm === "") {
    return true;
  }
  return roles.some((role) => route.pm === role);
}


const permission = {
  state: {
    routers: constantRouterMap,
    addRouters: [],
    comUri: {}
  },
  mutations: {
    SET_ROUTERS: (state, routers) => {
      state.addRouters = routers;
      // route.addRoutes(routers)
      localStorage.setItem('addRData', JSON.stringify(routers))
      state.routers = constantRouterMap.concat(routers);
    },
    SET_COM_URI: (state, array = []) => {
      state.comUri = array
    }
  },
  actions: {
    setRouters({ commit }, data) {
      commit('SET_ROUTERS', data)
    },
    setComUri ({ commit }, data) {
      commit('SET_COM_URI', data)
    },
    generateRoutes({ commit }, data) {
      return new Promise(resolve => {
        const { roles } = data;

        commit('SET_ROUTERS', accessedRouters);
        resolve();
      })
    }
  }
}

export default permission;



// WEBPACK FOOTER //
// ./src/vuex/modules/permission.js